import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import React from 'react';
import { decryptVendorParams } from "../../utils/vendorCrypto";

const RequireAuth = ({ allowedRoles }) => {
    const location = useLocation()
    const user = JSON.parse(localStorage.getItem('user'));
    
    // Check for vendor link parameters
    const searchParams = new URL(window.location.href).searchParams;
    const vToken = searchParams.get("vToken");
    const decrypted = decryptVendorParams(vToken);
    
    const isVendorLink = (decrypted && decrypted.vId && decrypted.vEmail) || 
                         ((searchParams.get("vId") || searchParams.get("vld") || searchParams.get("vid")) && (searchParams.get("vEmail") || searchParams.get("vemail")));

    if (isVendorLink) {
        return <Outlet />;
    }

    if (user && (!allowedRoles || allowedRoles.includes(user.role))) {
        return <Outlet />;
    }

    return <Navigate to="/login" state={{ from: location }} replace />;
}
export default RequireAuth